import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import { 
  LayoutDashboard, 
  // Settings, 
  Users, 
  ShoppingCart,
  MessageSquare,
  // FileText,
  X,
  // Megaphone,
  // Zap,
  Package,
  UserCog,
  DollarSign,
  TrendingUp,
  Settings,
  Headphones,
  LayoutGrid,
  FileText,
  PieChart,
  CheckSquare,
  Mail,
  Facebook,
  ChevronLeft,
  ChevronRight,
  Server,
  Send,
  Workflow,
  Tag
} from 'lucide-react';

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ open, onClose }) => {
  const [collapsed, setCollapsed] = useState(false);
  // Recupera usuário e role do localStorage
  let role: string | null = null;
  try {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      role = user?.role || null;
    }
  } catch {
    role = null;
  }

  // Menus comuns a todos
  const commonMenus = (
    <>
      <NavLink 
        to="/" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        end
        title="Dashboard"
      >
        <LayoutDashboard className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Dashboard'}
      </NavLink>
      <NavLink 
        to="/usuarios" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Usuários"
      >
        <Users className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Usuários'}
      </NavLink>
      <NavLink 
        to="/listas" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Listas de Compras"
      >
        <ShoppingCart className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Listas de Compras'}
      </NavLink>
      <NavLink 
        to="/invoices" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Invoices"
      >
        <FileText className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Invoices'}
      </NavLink>
      <NavLink 
        to="/vendas" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Vendas"
      >
        <DollarSign className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Vendas'}
      </NavLink>
      <NavLink 
        to="/comissoes" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Comissões"
      >
        <TrendingUp className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Comissões'}
      </NavLink>
      <NavLink 
        to="/atendimento" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Chat ao vivo"
      >
        <Headphones className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Chat ao vivo'}
      </NavLink>
      <NavLink 
        to="/tarefas" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Tarefas"
      >
        <CheckSquare className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Tarefas'}
      </NavLink>
    </>
  );
  // Menus exclusivos de admin
  const adminMenus = (
    <>
      <NavLink 
        to="/painel-atendimento" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Painel Atendimento"
      >
        <LayoutGrid className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Painel Atendimento'}
      </NavLink>
      <NavLink 
        to="/relatorio-atendimento" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Relatório Geral"
      >
        <FileText className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Relatório Geral'}
      </NavLink>
      <NavLink 
        to="/estatisticas" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Estatísticas"
      >
        <PieChart className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Estatísticas'}
      </NavLink>
      <NavLink 
        to="/email-templates" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Templates Email"
      >
        <Mail className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Templates Email'}
      </NavLink>
      <NavLink 
        to="/campaign-segments" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Segmentos"
      >
        <Users className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Segmentos'}
      </NavLink>
      <NavLink 
        to="/campanhas-email" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Campanhas Email"
      >
        <Mail className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Campanhas Email'}
      </NavLink>
      <NavLink 
        to="/smtp-configs" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Configurações SMTP"
      >
        <Server className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'SMTP Configs'}
      </NavLink>
      <NavLink 
        to="/bulk-email-campaigns" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Email em Massa"
      >
        <Send className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Email em Massa'}
      </NavLink>
      <NavLink 
        to="/email-workflows" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Workflows de Email"
      >
        <Workflow className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Workflows'}
      </NavLink>
      <NavLink 
        to="/email-tags" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Tags de Email"
      >
        <Tag className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Tags'}
      </NavLink>
      <NavLink 
        to="/configuracao-comissoes" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Config. Comissões"
      >
        <Settings className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Config. Comissões'}
      </NavLink>
      <NavLink 
        to="/assinaturas" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Assinaturas"
      >
        <Package className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Assinaturas'}
      </NavLink>
      <NavLink 
        to="/gerenciar-usuarios" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Gerenciar Usuários"
      >
        <UserCog className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Gerenciar Usuários'}
      </NavLink>
      <NavLink 
        to="/configuracoes" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Configurações"
      >
        <Settings className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Configurações'}
      </NavLink>
      <NavLink 
        to="/meta-funil" 
        className={({ isActive }) => 
          `flex items-center ${collapsed ? 'justify-center px-3 py-4' : 'px-4 py-3'} text-sm font-medium rounded-lg transition-colors ${
            isActive 
              ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' 
              : 'text-gray-700 hover:bg-gray-100'
          }`
        }
        title="Meta Funil"
      >
        <Facebook className={collapsed ? 'h-10 w-10' : 'h-5 w-5 mr-3'} />
        {!collapsed && 'Meta Funil'}
      </NavLink>
    </>
  );

  return (
    <>
      {/* Mobile backdrop */}
      {open && (
        <div 
          className="fixed inset-0 z-20 bg-black bg-opacity-50 lg:hidden" 
          onClick={onClose}
        />
      )}
      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-30 transform bg-white shadow-xl transition-all duration-300 ease-in-out 
        lg:translate-x-0 lg:static lg:inset-0 lg:z-auto
        ${open ? 'translate-x-0' : '-translate-x-full'}
        ${collapsed ? 'w-24' : 'w-64'}
      `}>
        <div className="flex h-screen flex-col">
          {/* Header */}
          <div className={`flex h-16 items-center ${collapsed ? 'justify-center px-2' : 'justify-between px-6'} border-b border-gray-200`}>
            {!collapsed && (
              <div className="flex items-center">
                <MessageSquare className="h-8 w-8 text-blue-600" />
                <h1 className="ml-3 text-xl font-bold text-gray-900">ChatBot CRM</h1>
              </div>
            )}
            {collapsed && (
              <MessageSquare className="h-8 w-8 text-blue-600" />
            )}
            <button className="lg:hidden" onClick={onClose}>
              <X className="h-6 w-6 text-gray-500" />
            </button>
          </div>
          {/* Navigation */}
          <nav className="flex-1 overflow-y-auto px-4 py-6 space-y-2">
            {commonMenus}
            {role === 'admin' && adminMenus}
          </nav>
          {/* Toggle Button */}
          <div className="border-t border-gray-200 p-4">
            <button
              onClick={() => setCollapsed(!collapsed)}
              className="hidden lg:flex w-full items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
              title={collapsed ? 'Expandir menu' : 'Recolher menu'}
            >
              {collapsed ? (
                <ChevronRight className="h-5 w-5" />
              ) : (
                <>
                  <ChevronLeft className="h-5 w-5 mr-2" />
                  Recolher
                </>
              )}
            </button>
          </div>
          {/* Footer */}
          <div className="border-t border-gray-200 p-4">
            <div className={`flex items-center ${collapsed ? 'justify-center' : ''}`}>
              <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                <span className="text-sm font-medium text-blue-700">OS</span>
              </div>
              {!collapsed && (
                <div className="ml-3">
                  <p className="text-sm font-medium text-gray-900">by OnSolutions</p>
                  <p className="text-xs text-gray-500">Sistema CRM</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;